import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import ListaDeMonedasConstant from 'constants/listaDeMonedas'

const MonedaFormGroup = ({ iError, iTouched, fIsSubmitting, vTipo }) => {
  return (
    <Form.Group>
      <Form.Label text='MONEDA' htmlFor='select-moneda' md={4} />
      <Col md={8}>
        <Field name='moneda'>
          {({ field }) => (
            <Form.Select
              {...field}
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
              id='select-moneda'
            >
              <option value=''>Seleccionar</option>
              <option value={ListaDeMonedasConstant.SOLES}>
                {ListaDeMonedasConstant.__dictionary[ListaDeMonedasConstant.SOLES].nombre}
              </option>
              <option value={ListaDeMonedasConstant.DOLARES}>
                {ListaDeMonedasConstant.__dictionary[ListaDeMonedasConstant.DOLARES].nombre}
              </option>
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(MonedaFormGroup)
